import type { TestId } from '@repo/test-id';
import { tr } from '@repo/locale';

import PromoCarouselSlide from '@features/promo/components/PromoCarouselSlide';

import parkedCar from '@assets/images/promo/parked-car.webp';
import parkingSign from '@assets/images/parking-sign.webp';

interface Props {
  testId: TestId;
}

export default function EntranceCarParkedSlide({ testId }: Props) {
  return (
    <PromoCarouselSlide
      title={tr('promo:entrance.car_parked.title')}
      points={[
        { label: tr('promo:entrance.car_parked.point_1') },
        { label: tr('promo:entrance.car_parked.point_3') },
        { label: tr('promo:entrance.car_parked.point_2'), isSoon: true },
      ]}
      testId={testId}
      theme="blue"
    >
      <img src={parkedCar} alt="" aria-hidden="true" className="absolute top-24 w-60" />
      <img src={parkingSign} alt="" aria-hidden="true" className="absolute -top-10 right-20 size-30 blur-xs" />
    </PromoCarouselSlide>
  );
}
